import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FaHome } from "react-icons/fa";

const LOGO_URL = "https://benton.lightideaproductions.co.uk/logo.png";

export default function Header() {
  const location = useLocation();

  const isHomeActive =
    location.pathname === "/home" || location.pathname === "/";

  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-[rgba(8,17,31,0.78)] backdrop-blur-xl">
      <div className="mx-auto flex max-w-[1800px] items-center justify-between px-3 py-4 sm:px-4 lg:px-6">
        <div className="min-w-0">
          <div className="flex items-center gap-4">
            <img
              src={LOGO_URL}
              alt="Benton Theatres Logo"
              className="h-16 w-16 object-contain sm:h-20 sm:w-20"
            />
            <div className="min-w-0">
              <div className="truncate text-2xl font-semibold tracking-tight text-white sm:text-3xl">
                Benton Theatres
              </div>
              <div className="text-sm uppercase tracking-[0.22em] text-white/45 sm:text-base">
                Online Booking System
              </div>
            </div>
          </div>
        </div>

        <nav className="flex items-center gap-2 sm:gap-3">
          <Link
            to="/home"
            className={`inline-flex items-center gap-2 rounded-2xl border px-4 py-2 text-sm font-medium transition ${
              isHomeActive
                ? "border-cyan-300/40 bg-cyan-400/10 text-cyan-100"
                : "border-white/10 bg-white/[0.05] text-white/85 hover:bg-white/[0.08]"
            }`}
          >
            <span className="text-xs">
              <FaHome />
            </span>
            <span>Home</span>
          </Link>
        </nav>
      </div>
    </header>
  );
}